import React from "react"
import Card from "../../../atoms/Card.atom"
import { Skeleton } from "../../../atoms/misc/Skeleton.atom"
import ProgressSpinner from "../../../atoms/misc/ProgressSpinner.atom"

export const CONTAINER_OF_CHART_LOADING_MODES = {
  SKELETON: "skeleton",
  SPINNER: "spinner",
}
const ContainerOfChart = ({
  withWhiteBackgroundColor = true,
  title = "",
  icon,
  iconClassName,
  children,
  className,
  shadow = true,
  style,
  loading,
  loadingMode = CONTAINER_OF_CHART_LOADING_MODES.SKELETON,
}) => {
  const DEFAULT_SHADOW = "shadow-2"
  if (loading) {
    return (
      <Card
        className={`pie-container custom-recharts-container ${shadow ? DEFAULT_SHADOW : "shadow-none"} ${className}`}
        style={style}
      >
        {loadingMode === CONTAINER_OF_CHART_LOADING_MODES.SKELETON && (
          <Skeleton id="charts-skeleton" height={380} />
        )}
        {loadingMode === CONTAINER_OF_CHART_LOADING_MODES.SPINNER && (
          <div className="w-full h-28rem flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        )}
      </Card>
    )
  }
  if (withWhiteBackgroundColor) {
    return (
      <Card
        className={`pie-container custom-recharts-container ${shadow ? DEFAULT_SHADOW : "shadow-none"} ${className}`}
        style={style}
      >
        {title && (
          <div className="flex gap-2 align-items-center">
            {iconClassName ?
              <i
                className={`${iconClassName}`}
                style={{
                  color:
                    "light-dark(var(--primary-color-highlight), var(--surface-highlight__light))",
                }}
              />
            : icon}
            <span
              style={{ fontSize: "min(3.25vw, 18px)", lineHeight: "1" }}
              className="font-semibold"
            >
              {title}
            </span>
          </div>
        )}
        {children}
      </Card>
    )
  }
  return children
}

export default ContainerOfChart
